import { useEffect, useState } from 'react'

export function computeVisualViewportBottomOffsetPx(params: {
  innerHeight: number
  visualViewportHeight: number
  visualViewportOffsetTop: number
}): number {
  const raw = params.innerHeight - (params.visualViewportHeight + params.visualViewportOffsetTop)
  return raw > 0 ? raw : 0
}

/**
 * Returns a pixel offset that represents the portion of the layout viewport
 * that is currently occluded at the bottom (mobile browser UI and/or keyboard).
 *
 * Intended usage: apply as a CSS variable and add it to `bottom:` on fixed footers.
 */
export function useVisualViewportBottomOffset(): number {
  const [offsetPx, setOffsetPx] = useState(0)

  useEffect(() => {
    const vv = window.visualViewport
    if (!vv) {
      setOffsetPx(0)
      return
    }

    const update = () => {
      setOffsetPx(
        computeVisualViewportBottomOffsetPx({
          innerHeight: window.innerHeight,
          visualViewportHeight: vv.height,
          visualViewportOffsetTop: vv.offsetTop,
        })
      )
    }

    update()

    vv.addEventListener('resize', update)
    vv.addEventListener('scroll', update)
    window.addEventListener('resize', update)

    return () => {
      vv.removeEventListener('resize', update)
      vv.removeEventListener('scroll', update)
      window.removeEventListener('resize', update)
    }
  }, [])

  return offsetPx
}
